import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    appList: [],
    selectedAppDetail: null,
    subscribedAppList: []
};

export const appSlice = createSlice({
    name: "footerlink",
    initialState,
    reducers: {
        updateAppList: (state, action) => {
            state.appList = action.payload;
        },
        clearAppList: (state) => {
            state.appList = [];
        },
        updateSubscribeAppList: (state, action) => {
            state.subscribedAppList = action.payload;
        },
        clearSubscribeAppList: (state) => {
            state.subscribedAppList = [];
        },
        updateSelectedAppDetail: (state, action) => {
            state.selectedAppDetail = action.payload;
        },
        clearSelectedAppDetail: (state) => {
            state.selectedAppDetail = null;
        },    
    },
});

export const { updateAppList, clearAppList,updateSubscribeAppList, clearSubscribeAppList, updateSelectedAppUrl, clearSelectedAppUrl, updateSelectedAppDetail, clearSelectedAppDetail } = appSlice.actions;

export default appSlice.reducer;